import { QueryClient } from "react-query";

// Shared instance so non-React modules (api.js, session.js) can drop cached
// data on logout without importing the app tree.
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnReconnect: true,
			staleTime: 1000 * 60,
			cacheTime: 1000 * 60 * 15,
		},
	},
});

export default queryClient;
